<script lang="ts">
    import { routes } from '#lib/routes/index.ts';
    import { Button } from '#comp/ui/button/index.ts';
    import { fly } from 'svelte/transition';
    import { quadInOut } from 'svelte/easing';
    import { getCookie } from '#lib/utils/cookies.ts';
    import { SvelteDate } from 'svelte/reactivity';

    const KEY_ACCEPT_COOKIES = 'acceptCookies';
    let showBanner = getCookie(KEY_ACCEPT_COOKIES) == null;

    function accept(all: boolean) {
        const value = all ? 'all' : 'necessary';
        const oneYear = new SvelteDate();
        oneYear.setFullYear(oneYear.getFullYear() + 1);
        document.cookie = `${KEY_ACCEPT_COOKIES}=${value}; path=/; expires=${oneYear.toUTCString()}`;
        showBanner = false;
    }
</script>

{#if showBanner}
    <div
        transition:fly={{ easing: quadInOut, y: 20, opacity: 0, duration: 300 }}
        class="fixed bottom-0 z-50 flex w-full flex-row items-center border bg-white p-8">
        <img src="/images/cookie-policy.svg" alt="Cookie policy" class="hidden pr-8 sm:block" />
        <div class="flex flex-col items-start gap-4 text-gray-600">
            <p>
                We use cookies to enable essential and secure site functionality and performance. See our <a
                    href={routes.open.terms()}
                    class="text-primary underline"
                    target="_blank">
                    cookie policy
                </a>
                for more details.
            </p>
            <div class="flex flex-row gap-4">
                <Button onclick={() => accept(true)} variant="primary" id="accept-all-cookies">Accept All</Button>
                <Button onclick={() => accept(false)} variant="outline" class="text-gray-500">Accept Necessary</Button>
            </div>
        </div>
    </div>
    <div class="h-48 bg-white">
        <!--
            Add extra space at the bottom so the content's bottom
            still has room to show above the cookie banner.
        -->
    </div>
{/if}
